import { ConfigurationTypes } from '../../../types/clinic/configurations/configuration-types'
import { axios, Response } from '../index'

export interface GetConfigurationsResponse {
  id: string
  typeSettings: ConfigurationTypes
  title: string
  description: string
  isCheck: boolean
}

const updateConfigurations = (): Response<GetConfigurationsResponse[]> => {
  return axios.put(`/v1/settings`)
}

export default updateConfigurations
